import { getRoleLabel, isTicketAssignableRole, normalizeRole } from './rbac';

const buildSearchText = (user) => (
  [
    user?.full_name,
    user?.username,
    user?.email,
    getRoleLabel(user?.role)
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
);

export const isAssignableUser = (user) => (
  isTicketAssignableRole(user?.role) && user?.is_active !== false
);

export const buildAssignableUserOption = (user) => {
  if (!user) return null;

  const value = Number.parseInt(user.id, 10);
  if (!Number.isInteger(value)) return null;

  const role = normalizeRole(user.role);
  const roleLabel = getRoleLabel(role);
  const label = user.full_name || user.username || user.email || `#${value}`;
  const meta = [
    user.username ? `@${user.username}` : null,
    roleLabel
  ]
    .filter(Boolean)
    .join(' • ');

  return {
    value,
    label,
    chipLabel: roleLabel ? `${label} (${roleLabel})` : label,
    meta,
    username: user.username || '',
    email: user.email || '',
    role,
    roleLabel,
    searchText: buildSearchText(user),
    raw: user
  };
};

export const normalizeAssignableUserOptions = (users = []) => {
  const seen = new Set();

  return (Array.isArray(users) ? users : [])
    .filter(isAssignableUser)
    .map(buildAssignableUserOption)
    .filter((option) => {
      if (!option || seen.has(option.value)) return false;
      seen.add(option.value);
      return true;
    })
    .sort((left, right) => left.label.localeCompare(right.label));
};

export const mapAssignedUsersToOptions = (assignedUsers = [], options = []) => {
  const optionMap = new Map(
    (Array.isArray(options) ? options : []).map((option) => [option.value, option])
  );
  const seen = new Set();

  return (Array.isArray(assignedUsers) ? assignedUsers : [])
    .map((user) => {
      const userId = Number.parseInt(user?.id, 10);
      if (!Number.isInteger(userId)) return null;

      const fromOptions = optionMap.get(userId);
      if (fromOptions) return fromOptions;

      if (isAssignableUser(user)) {
        return buildAssignableUserOption(user);
      }

      return null;
    })
    .filter((option) => {
      if (!option || seen.has(option.value)) return false;
      seen.add(option.value);
      return true;
    });
};
